<template>
    <router-link :to="{ name: 'Catchers', params: { id: catcher.id } }">
        <div class="catcher-card">{{catcher.name}}</div>
    </router-link>
</template>
<script>
export default {
    name: 'CatchCard',
    props: { catcher: Object },
};
</script>

<style lang="scss" scoped>
.catcher-card {
    background: white;
    margin: 0.2em;
    flex: 1;
    border: 1px solid rgb(230, 230, 230);
    border-radius: 5px;
    max-width: $maxContentWidth;
    text-align: center;
}
a {
    text-decoration: none;
}
.button {
    position: relative;
    cursor: pointer;
    font-size: 0.7rem;
    background-color: $backgroundColor;
    padding: 0rem 0.5rem 0.1rem 0.5rem;
    transition: all 0.2s ease-in-out;
    border: 1px solid lightgrey;
    border-radius: 4px;
    &:hover {
        border: 1px solid $borderColorHover;
    }
}
</style>
